<template>
  <div>这里是test组件{{title}}</div>
</template>
<script>
export default {
  name:"test",
  data(){
    return{
      title:"test"
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/test.vue